import { IS_DEV } from '../constants';

export const LOG_TAGS = {
  admob: '[Admob]',
  appleWatch: '[AppleWatch]',
  audioShoutout: '[AudioShoutout]',
  carPlay: '[CarPlay]',
  inAppReview: '[InAppReview]',
  podcasts: '[Podcasts]',
  push: '[Push]',
  rntp: '[RNTP]',
  rss: '[RSS]',
  tracking: '[Tracking]',
} as const;

// Add tags here (e.g. LOG_TAGS.adswizzBridge) to only show logs from those areas.
// Empty = show all.
const ACTIVE_TAGS: string[] = [];

const isTagActive = (tag: unknown): boolean =>
  ACTIVE_TAGS.length === 0 || ACTIVE_TAGS.includes(tag as string);

export const logger = {
  log: (...args: unknown[]): void => {
    if (IS_DEV && isTagActive(args[0])) {
      console.log(...args);
    }
  },
  info: (...args: unknown[]): void => {
    if (IS_DEV && isTagActive(args[0])) {
      console.info(...args);
    }
  },
  debug: (...args: unknown[]): void => {
    if (IS_DEV && isTagActive(args[0])) {
      console.debug(...args);
    }
  },
  warn: (...args: unknown[]): void => {
    if (IS_DEV && isTagActive(args[0])) {
      console.warn(...args);
    }
  },
  error: (...args: unknown[]): void => {
    if (IS_DEV && isTagActive(args[0])) {
      console.error(...args);
    }
  },
};
